var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// node_modules/pubsub-js/src/pubsub.js
var require_pubsub = __commonJS({
  "node_modules/pubsub-js/src/pubsub.js"(exports, module) {
    (function(root, factory) {
      "use strict";
      var PubSub2 = {};
      if (root.PubSub) {
        PubSub2 = root.PubSub;
        console.warn("PubSub already loaded, using existing version");
      } else {
        root.PubSub = PubSub2;
        factory(PubSub2);
      }
      if (typeof exports === "object") {
        if (module !== void 0 && module.exports) {
          exports = module.exports = PubSub2;
        }
        exports.PubSub = PubSub2;
        module.exports = exports = PubSub2;
      } else if (typeof define === "function" && define.amd) {
        define(function() {
          return PubSub2;
        });
      }
    })(typeof window === "object" && window || exports || global, function(PubSub2) {
      "use strict";
      var messages = {}, lastUid = -1, ALL_SUBSCRIBING_MSG = "*";
      function hasKeys(obj) {
        var key;
        for (key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            return true;
          }
        }
        return false;
      }
      function throwException(ex) {
        return function reThrowException() {
          throw ex;
        };
      }
      function callSubscriberWithDelayedExceptions(subscriber, message, data) {
        try {
          subscriber(message, data);
        } catch (ex) {
          setTimeout(throwException(ex), 0);
        }
      }
      function callSubscriberWithImmediateExceptions(subscriber, message, data) {
        subscriber(message, data);
      }
      function deliverMessage(originalMessage, matchedMessage, data, immediateExceptions) {
        var subscribers = messages[matchedMessage], callSubscriber = immediateExceptions ? callSubscriberWithImmediateExceptions : callSubscriberWithDelayedExceptions, s;
        if (!Object.prototype.hasOwnProperty.call(messages, matchedMessage)) {
          return;
        }
        for (s in subscribers) {
          if (Object.prototype.hasOwnProperty.call(subscribers, s)) {
            callSubscriber(subscribers[s], originalMessage, data);
          }
        }
      }
      function createDeliveryFunction(message, data, immediateExceptions) {
        return function deliverNamespaced() {
          var topic = String(message), position = topic.lastIndexOf(".");
          deliverMessage(message, message, data, immediateExceptions);
          while (position !== -1) {
            topic = topic.substr(0, position);
            position = topic.lastIndexOf(".");
            deliverMessage(message, topic, data, immediateExceptions);
          }
          deliverMessage(message, ALL_SUBSCRIBING_MSG, data, immediateExceptions);
        };
      }
      function hasDirectSubscribersFor(message) {
        var topic = String(message), found = Boolean(Object.prototype.hasOwnProperty.call(messages, topic) && hasKeys(messages[topic]));
        return found;
      }
      function messageHasSubscribers(message) {
        var topic = String(message), found = hasDirectSubscribersFor(topic) || hasDirectSubscribersFor(ALL_SUBSCRIBING_MSG), position = topic.lastIndexOf(".");
        while (!found && position !== -1) {
          topic = topic.substr(0, position);
          position = topic.lastIndexOf(".");
          found = hasDirectSubscribersFor(topic);
        }
        return found;
      }
      function publish(message, data, sync, immediateExceptions) {
        message = typeof message === "symbol" ? message.toString() : message;
        var deliver = createDeliveryFunction(message, data, immediateExceptions), hasSubscribers = messageHasSubscribers(message);
        if (!hasSubscribers) {
          return false;
        }
        if (sync === true) {
          deliver();
        } else {
          setTimeout(deliver, 0);
        }
        return true;
      }
      PubSub2.publish = function(message, data) {
        return publish(message, data, false, PubSub2.immediateExceptions);
      };
      PubSub2.publishSync = function(message, data) {
        return publish(message, data, true, PubSub2.immediateExceptions);
      };
      PubSub2.subscribe = function(message, func) {
        if (typeof func !== "function") {
          return false;
        }
        message = typeof message === "symbol" ? message.toString() : message;
        if (!Object.prototype.hasOwnProperty.call(messages, message)) {
          messages[message] = {};
        }
        var token = "uid_" + String(++lastUid);
        messages[message][token] = func;
        return token;
      };
      PubSub2.subscribeAll = function(func) {
        return PubSub2.subscribe(ALL_SUBSCRIBING_MSG, func);
      };
      PubSub2.subscribeOnce = function(message, func) {
        var token = PubSub2.subscribe(message, function() {
          PubSub2.unsubscribe(token);
          func.apply(this, arguments);
        });
        return PubSub2;
      };
      PubSub2.clearAllSubscriptions = function clearAllSubscriptions() {
        messages = {};
      };
      PubSub2.clearSubscriptions = function clearSubscriptions(topic) {
        var m;
        for (m in messages) {
          if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0) {
            delete messages[m];
          }
        }
      };
      PubSub2.countSubscriptions = function countSubscriptions(topic) {
        var m;
        var token;
        var count = 0;
        for (m in messages) {
          if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0) {
            for (token in messages[m]) {
              count++;
            }
            break;
          }
        }
        return count;
      };
      PubSub2.getSubscriptions = function getSubscriptions(topic) {
        var m;
        var list = [];
        for (m in messages) {
          if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0) {
            list.push(m);
          }
        }
        return list;
      };
      PubSub2.unsubscribe = function(value) {
        var descendantTopicExists = function(topic) {
          var m2;
          for (m2 in messages) {
            if (Object.prototype.hasOwnProperty.call(messages, m2) && m2.indexOf(topic) === 0) {
              return true;
            }
          }
          return false;
        }, isTopic = typeof value === "string" && (Object.prototype.hasOwnProperty.call(messages, value) || descendantTopicExists(value)), isToken = !isTopic && typeof value === "string", isFunction = typeof value === "function", result = false, m, message, t;
        if (isTopic) {
          PubSub2.clearSubscriptions(value);
          return;
        }
        for (m in messages) {
          if (Object.prototype.hasOwnProperty.call(messages, m)) {
            message = messages[m];
            if (isToken && message[value]) {
              delete message[value];
              result = value;
              break;
            }
            if (isFunction) {
              for (t in message) {
                if (Object.prototype.hasOwnProperty.call(message, t) && message[t] === value) {
                  delete message[t];
                  result = true;
                }
              }
            }
          }
        }
        return result;
      };
    });
  }
});

// src/utils/constants.js
var PUB_SUB_EVENTS = {
  colorChange: "color-change",
  sizeChange: "size-change",
  variantChange: "variant-change",
  blindsChange: "blinds-change",
  initialize: "initialize",
  onlyUpdateUrl: "only-update-url",
  blindsUpdatePrice: "blinds-update-price",
  updateControls: "update-controls",
  upsellChange: "upsell-change"
};

// src/utils/dissect-form.js
var dissectForm = (formData) => {
  var _a;
  const defaultQuantity = 1;
  const variantID = formData.get("id") ? formData.get("id") : null;
  const quantity = formData.get("quantity") ? formData.get("quantity") : defaultQuantity;
  const color = formData.get("color") ? formData.get("color") : null;
  const colorStyle = formData.get("colorStyle") ? formData.get("colorStyle") : null;
  const colorFinish = formData.get("colorFinish") ? formData.get("colorFinish") : null;
  const width = formData.get("width") ? formData.get("width") : null;
  const height = formData.get("height") ? formData.get("height") : null;
  const note = formData.get("note") ? formData.get("note") : null;
  const slatWidth = formData.get("slatWidth") ? formData.get("slatWidth") : null;
  const frameSpacing = formData.get("frameSpacing") ? formData.get("frameSpacing") : null;
  const ladderTaping = formData.get("ladderTaping") ? formData.get("ladderTaping") : null;
  const colorCode = formData["_color_code"] ? formData["_color_code"] : null;
  const ladderTapingColor = formData.get("ladderTapingColor") ? formData.get("ladderTapingColor") : null;
  const controls = formData.get("controls") ? formData.get("controls") : null;
  const ladderkoordMatchend = formData.get("_ladder_cord_matchend") ? formData.get("_ladder_cord_matchend") : null;
  const bakAndLatkleur = formData.get("_top_and_bottom_rail") ? formData.get("_top_and_bottom_rail") : null;
  const ladderbandMatchend = formData.get("_ladder_strap_matchend") ? formData.get("_ladder_strap_matchend") : null;
  const itemIdForMainProduct = Date.now().toString(36) + Math.random().toString(36).substring(2);
  const topBottomRailId = formData.get("_topBottomRailId") ? formData.get("_topBottomRailId") : null;
  const topBottomRailColor = formData.get("topBottomRailColor") ? formData.get("topBottomRailColor") : null;
  const allUpSellRawData = formData.get("_upSellIds") ? formData.get("_upSellIds") : null;
  const baseboardVariantId = formData.get("_baseboard_variant_id") ? formData.get("_baseboard_variant_id") : null;
  const cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
  const data = {
    items: [
      {
        id: variantID,
        quantity,
        "product-id": formData.get("product-id"),
        properties: {
          "_parentId": itemIdForMainProduct
        }
      }
    ],
    sections: cart.getSectionsToRender().map((section) => section.id)
  };
  if (allUpSellRawData && allUpSellRawData.length > 0) {
    const allUpsellObjects = JSON.parse(allUpSellRawData);
    allUpsellObjects.forEach((upSellObject) => {
      if (baseboardVariantId && baseboardVariantId == upSellObject.id) {
        data.items.push({
          id: upSellObject.id,
          quantity: 1,
          properties: {
            "_isUpSell": true,
            "_parentId": itemIdForMainProduct,
            Width: width,
            Height: height,
            "Baseboard left height": `${formData.get("baseboard_left_height")}mm`,
            "Baseboard left depth": `${formData.get("baseboard_left_depth")}mm`,
            "Baseboard right height": `${formData.get("baseboard_right_height")}mm`,
            "Baseboard right depth": `${formData.get("baseboard_right_depth")}mm`
          }
        });
      } else {
        data.items.push({
          id: upSellObject.id,
          quantity: 1,
          properties: {
            "_isUpSell": true,
            "_parentId": itemIdForMainProduct,
            Width: width,
            Height: height
          }
        });
      }
    });
    data.items[0].properties[`_${window.cart.extras.toLowerCase()}`] = allUpsellObjects.filter((upSellObject) => upSellObject.title).map((upSellObject) => upSellObject.title);
    data.items[0].properties["_extraIds"] = allUpsellObjects.filter((upSellObject) => upSellObject.id).map((upSellObject) => upSellObject.id);
  }
  if (topBottomRailId) {
    data.items.push({
      id: topBottomRailId,
      quantity: 1,
      properties: {
        "_isTopBottomRail": true,
        "_parentId": itemIdForMainProduct,
        "Color": topBottomRailColor
      }
    });
  }
  const abz = formData.get("slatWidth") === "25mm" ? "3810-1002" : "3810-1004";
  const bottomBarId = formData.get("slatWidth") === "25mm" ? "EOS" : "50";
  const bottomRailColorChange = formData.get("topBottomRailColor") === "Matchend" ? "False" : "True";
  const bottomRailColorId = formData.get("topBottomRailColor") === "White" ? "0000" : "1858";
  const controlSideLift = formData.get("controls") === "shared" || formData.get("controls") == "Left" ? "Left" : "Right";
  const controlSideTilt = formData.get("controls") === "shared" || formData.get("controls") == "Left" ? "Left" : "Right";
  const childSafe = "True";
  const cordTape = formData.get("ladderTaping") === "ladderCord" ? "False" : "True";
  const tapeId = formData.get("slatWidth") === "25mm" ? "25" : "50";
  const customerID = 901740;
  const operationTypeId = formData.get("slatWidth") === "25mm" ? "CordWand" : "CordCord";
  const productColour = formData.get("_color_code");
  const slatTypeID = formData.get("slatWidth") === "25mm" ? "25" : "50";
  const sizeGuideID = ((_a = formData.get("_upSellIds")) == null ? void 0 : _a.includes("Zijgeleiding")) ? "True" : "False";
  if (abz) {
    data.items[0].properties["_ABZitem_ID"] = abz;
  }
  if (bottomBarId) {
    data.items[0].properties["_BottomBar_ID"] = bottomBarId;
  }
  if (bottomRailColorChange) {
    data.items[0].properties["_BottomRailColourChange"] = bottomRailColorChange;
  }
  if (bottomRailColorId) {
    data.items[0].properties["_BottomRailColour_ID"] = bottomRailColorId;
  }
  if (childSafe) {
    data.items[0].properties["_ChildSafe"] = childSafe;
  }
  if (controlSideLift) {
    data.items[0].properties["_ControlSideLift_ID"] = controlSideLift;
  }
  if (controlSideTilt) {
    data.items[0].properties["_ControlSideTilt_ID"] = controlSideTilt;
  }
  if (cordTape) {
    data.items[0].properties["_CordTape"] = cordTape;
  }
  if (formData.get("CordTape") === "False") {
    switch (formData.get("topBottomRailColor")) {
      case "matchend":
        data.items[0].properties["_CordTapeColourID"] = formData.get("_ladder_strap_matchend");
        break;
      case "white":
        data.items[0].properties["_CordTapeColourID"] = formData.get("_ladder_strap_white");
        break;
      case "black":
        data.items[0].properties["_CordTapeColourID"] = formData.get("_ladder_strap_black");
        break;
      default:
        data.items[0].properties["_CordTapeColourID"] = formData.get("_ladder_strap_matchend");
    }
  } else {
    switch (formData.get("topBottomRailColor")) {
      case "matchend":
        data.items[0].properties["_CordTapeColourID"] = formData.get("_ladder_cord_matchend");
        break;
      case "white":
        data.items[0].properties["_CordTapeColourID"] = formData.get("_ladder_cord_white");
        break;
      case "black":
        data.items[0].properties["_CordTapeColourID"] = formData.get("_ladder_cord_black");
        break;
      default:
        data.items[0].properties["_CordTapeColourID"] = formData.get("_ladder_cord_matchend");
    }
  }
  if (tapeId) {
    data.items[0].properties["_TapeID"] = "25";
  }
  if (customerID) {
    data.items[0].properties["_Customer_ID"] = customerID;
  }
  if (operationTypeId) {
    data.items[0].properties["_OperationType_ID"] = operationTypeId;
  }
  if (productColour) {
    data.items[0].properties["_ProductColour"] = productColour;
  }
  if (height) {
    data.items[0].properties["_ProductHeight"] = height;
  }
  data.items[0].properties["_ProductType_ID"] = "Standard";
  data.items[0].properties["_type"] = "blinds";
  if (width) {
    data.items[0].properties["_ProductWidth"] = width;
  }
  if (slatTypeID) {
    data.items[0].properties["_SlatType_ID"] = slatTypeID;
  }
  if (sizeGuideID) {
    data.items[0].properties["_SizeGuide_ID"] = sizeGuideID;
  }
  if (color) {
    const strippedFinish = color.split(" -")[0];
    data.items[0].properties["Color"] = strippedFinish;
  }
  if (colorStyle) {
    data.items[0].properties["Color style"] = colorStyle;
  }
  if (colorFinish) {
    data.items[0].properties["Color finish"] = colorFinish;
  }
  if (width) {
    data.items[0].properties["Width"] = width;
  }
  if (height) {
    data.items[0].properties["Height"] = height;
  }
  if (note) {
    data.items[0].properties["Room or note"] = note;
  }
  if (slatWidth) {
    data.items[0].properties["Slat width"] = slatWidth;
  }
  if (frameSpacing) {
    data.items[0].properties["Placement"] = frameSpacing;
  }
  if (ladderTaping) {
    data.items[0].properties["Ladder taping"] = ladderTaping;
  }
  if (ladderTapingColor) {
    data.items[0].properties["Ladder taping color"] = ladderTapingColor;
  }
  if (controls) {
    data.items[0].properties["Controls"] = controls;
  }
  if (colorCode) {
    data.items[0].properties["_Kleurcode"] = colorCode;
  }
  if (ladderkoordMatchend && ladderkoordMatchend !== "undefined") {
    data.items[0].properties["_Ladderkoordkleur"] = ladderkoordMatchend;
  }
  if (ladderbandMatchend && ladderbandMatchend !== "undefined") {
    data.items[0].properties["_Ladderbandkleur"] = ladderbandMatchend;
  }
  if (bakAndLatkleur && bakAndLatkleur !== "undefined") {
    data.items[0].properties["_Bak & latkleur 25mm"] = formData.get("_bak_lat_kleur_25mm");
    data.items[0].properties["_Bak & latkleur 50mm"] = formData.get("_bak_lat_kleur_50mm");
  }
  data.items[0].properties["_Brackets color"] = formData.get("_brackets_color");
  data.items[0].properties["_Cord holders color"] = formData.get("_cord_holders_color");
  const configureUrl = new URL(window.location);
  data.items[0].properties["_reconfigureUrl"] = configureUrl;
  return JSON.stringify(data);
};

// src/extenders/blinds-form.js
var import_pubsub_js = __toESM(require_pubsub(), 1);
if (!customElements.get("blinds-form")) {
  customElements.define(
    "blinds-form",
    class BlindsForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.allInputElements = this.form.querySelectorAll("input, select, textarea, button");
        this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
        this.hideErrors = this.dataset.hideErrors === "true";
      }
      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true")
          return;
        this.handleErrorMessage();
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.setAttribute("aria-busy", true);
        const config = {
          method: "POST",
          headers: {
            "Content-Type": "application/json; charset=utf-8",
            "X-Requested-With": "xmlhttprequest"
          }
        };
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
        }
        config.body = formData;
        if (formData.get("size-variant-id")) {
          const constructNewFormData = new FormData();
          formData.forEach((value, key) => {
            if (key !== "id" && key !== "product-id" && key !== "size-variant-id" && key !== "size-product-id") {
              constructNewFormData.append(key, value);
            }
          });
          constructNewFormData.append("id", formData.get("size-variant-id"));
          constructNewFormData.append("product-id", formData.get("size-product-id"));
          config.body = dissectForm(constructNewFormData);
        }
        fetch(`${routes.cart_add_url}.js`, config).then((response) => response.json()).then((response) => {
          if (response.status) {
            import_pubsub_js.PubSub.publish(PUB_SUB_EVENTS.cartError, {
              source: "product-form",
              productVariantId: formData.get("id"),
              errors: response.errors || response.description,
              message: response.message
            });
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
            if (!soldOutMessage)
              return;
            this.submitButton.setAttribute("aria-disabled", true);
            this.submitButtonText.classList.add("hidden");
            soldOutMessage.classList.remove("hidden");
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          if (!this.error) {
            import_pubsub_js.PubSub.publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "product-form",
              productVariantId: formData.get("id"),
              cartData: response
            });
          }
          this.error = false;
        }).catch((e) => {
          console.error(e);
        }).finally(() => {
          this.submitButton.setAttribute("aria-busy", false);
          if (!this.error)
            this.submitButton.removeAttribute("aria-disabled");
        });
      }
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors)
          return;
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper)
          return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");
        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text)
            this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.add_to_cart;
        }
      }
      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
